import React from 'react';
import Navbar from '../components/Navbar';
import HeroSection from '../components/Hero';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
